<template src='./list.pug' lang='pug'></template>

<script>
import _ from 'underscore'
import vSelect from 'vue-select'
import GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import DateRange from '../../../input/dateRange/DateRange'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import language from '../../../../../build/language/index'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import { generateFinMovFromNode, generateAccountEntryFromNode } from '../../../../utils/transformationData.js'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import closeModal from '../../../../events/closeModal'
import IdSituacaoTarefaEnum from '../../../../enum/idSituacaoTarefa'
import FiltroSituacaoTarefaEnum from '../../../../enum/tipoFiltroSituacaoTarefas'
import FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'

export default {
  name: 'AssignmentList',

  components: {
    vSelect,
    GridDetailsModal,
    PageTitle,
    FilterPortlet,
    DateRange,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      defaultTab: 'gridDetailsModal-tabDetails',
      // Variáveis utilizadas para montar a treegrid
      gridId: '#assignmentGrid',
      result: {},
      treeGridCfg: {},
      exportUrl: EXPORT_TREEGRID,
      showTreegrid: false,
      // Array de base de consulta
      isOpenDetailsModal: false,
      queryBaseOptions: [
        {
          'id': 0,
          'label': this.$t('consultaTarefa.labels.todas'),
          'showDatePicker': false
        },
        {
          'id': 1,
          'label': this.$t('consultaTarefa.labels.dataCriacao'),
          'showDatePicker': true
        },
        {
          'id': 2,
          'label': this.$t('consultaTarefa.labels.dataVencimento'),
          'showDatePicker': true
        },
        {
          'id': 3,
          'label': this.$t('consultaTarefa.labels.dataConclusao'),
          'showDatePicker': true
        }
      ],
      showDate: false,
      // Array de tipos de ocorrência
      filteredOriginOptions: [],
      originalOriginOptions: [
        {
          'label': this.$t('consultaTarefa.labels.MF'),
          'key': 'MF'
        },
        {
          'label': this.$t('consultaTarefa.labels.CL'),
          'key': 'CL'
        }
      ],
      // Array de situações
      situationList: [
        {
          // Pendente
          id: IdSituacaoTarefaEnum.PENDENTE,
          nome: this.$t('consultaTarefa.labels.situacao.pendente'),
          checked: true
        },
        {
          // Em andamento
          id: IdSituacaoTarefaEnum.EM_ANDAMENTO,
          nome: this.$t('consultaTarefa.labels.situacao.emAndamento'),
          checked: true
        },
        {
          // Aguardando
          id: IdSituacaoTarefaEnum.AGUARDANDO,
          nome: this.$t('consultaTarefa.labels.situacao.aguardando'),
          checked: true
        },
        {
          // Concluído
          id: IdSituacaoTarefaEnum.CONCLUIDO,
          nome: this.$t('consultaTarefa.labels.situacao.concluido'),
          checked: true
        },
        {
          // Cancelado
          id: IdSituacaoTarefaEnum.CANCELADO,
          nome: this.$t('consultaTarefa.labels.situacao.cancelado'),
          checked: true
        }
      ],
      disableSearchButton: false,
      queryBaseSelected: {
        'id': 0,
        'label': this.$t('consultaTarefa.labels.todas'),
        'showDatePicker': false
      },
      typeLinkSelected: [],
      assignCheck: false,
      firstDate: new Date(),
      finalDate: new Date(),
      detailsObj: {
        establishtmentValue: {},
        mainValuesList: [],
        monetaryValuesList: [],
        statusValuesList: [],
        integrationValuesList: [],
        concSituation: null,
        idProcessamento: -1
      },
      modalId: '',
      modalDetailsTabs: [],
      finalDateDisable: new Date(),
      dateRange: {},
      modalTitle: null,
      modalSubTitle: null
    }
  },

  computed: {
    client () {
      return this.$store.getters.client
    },
    situationFilter () {
      return this.$store.getters.situationFilter
    }
  },

  methods: {
    // Método chamando na troca do select de base de consulta, para exibir ou esconder o date picker
    showDatePicker (val) {
      trackAnalyticsEvent(this, 'tarefas-select', 'base-consulta', val.label)
      // Se for data de vencimento (id=2) então não pode bloquear a data final
      if (val.id === 2) {
        this.finalDateDisable = null
      } else {
        this.finalDateDisable = new Date()
        this.firstDate = new Date()
        this.finalDate = new Date()
      }
      this.showDate = val.showDatePicker
      this.queryBaseSelected = val
    },

    trackCheckBox (event) {
      trackAnalyticsEvent(this, 'tarefas-check-box', 'tarefas-atribuidas-a-mim', event.target.checked ? 'marcada' : 'desmarcada')
    },

    trackCheckBoxSituacao (nomeSituacao) {
      trackAnalyticsEvent(this, 'tarefas-check-box', 'situacao-clicada', nomeSituacao)
    },

    trackOrigem (selectedOrigins) {
      this.filteredOriginOptions = _.difference(this.originalOriginOptions, selectedOrigins)
      if (selectedOrigins.length > 0) {
        let originsString = []
        selectedOrigins.forEach(element => {
          originsString.push(element.label)
        })
        trackAnalyticsEvent(this, 'tarefas-multi-select', 'origem-da-tarefa', originsString.toString())
      }
    },

    validate (event) {
      event.preventDefault()
      let self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (self.$refs.dateRange && !self.$refs.dateRange.validate()) {
            self.$root.$refs.notification.error('dateRange.validacao.dataInvalida')
            return
          }
          self.showTreegrid = true
          startTreeGridLoading(self.gridId)
          self.search()
        }
      })
    },

    // Faz a busca das tarefas
    search () {
      // Monta o array de tipo vinculo
      let typeLinkAux = this.createArrayTypeLinkFilter()

      // Monta o array de situações
      let situationListAux = this.createArraySituationListFilter()

      // Varíaveis de controle da tela
      this.disableSearchButton = true
      this.showTreegrid = true
      startTreeGridLoading(this.gridId)

      // Montando o filtro
      let filter = {
        usuarioLogadoResponsavel: this.assignCheck,
        idUsuarioResponsavel: 0,
        inicio: this.showDate ? this.dateRange.fromDate : new Date('2000', '01', '01'),
        fim: this.showDate ? this.dateRange.toDate : new Date(),
        baseConsulta: this.queryBaseSelected.id,
        tiposVinculo: typeLinkAux,
        situacoes: situationListAux,
        lang: language.getCookieByName('language')
      }

      trackAnalyticsEvent(this, 'tarefas-date-input', 'data-inicio', filter.inicio)
      trackAnalyticsEvent(this, 'tarefas-date-input', 'data-fim', filter.fim)

      // Dispara a action que faz a requisição no MS
      this.$store.dispatch('searchAssignment', filter)
        .then((response) => {
          window.DisposeGrids()
          this.treeGridCfg = response.data.treegrid.Cfg.Layout
          this.result = response.data.treegrid
          window.Grids.openAssignmentModal = (row) => {
            this.prepareGridReactions(row)
          }
          stopTreeGridLoading(this.gridId)
          this.disableSearchButton = false
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
          stopTreeGridLoading(this.gridId)
          this.disableSearchButton = false
        })

      if (this.situationFilter.fromDashboard) {
        this.dateRange.fromDate = new Date()
        this.dateRange.toDate = new Date()
        this.queryBaseSelected = this.queryBaseOptions.find(o => o.id === 0)
      }
    },

    prepareGridReactions (row) {
      this.modalId = 'finMovGridModalIdMov-' + row.IdVinculo
      this.defaultTab = 'gridDetailsModal-tabDetails'
      // Variáveis utilizadas para controle de qual modal será exibida (MF - Movimento financeiro, CL - Conta lançamento)
      let obj = {}
      let funcTrasform = null
      let funcTabs = null

      // Configuração dos objetos conforme o tipo vinculo
      if (row && row.TipoVinculo === 'MF') {
        obj.store = 'getFinancialMovByIdTask'
        obj.url = '/assignment/getFinancialMovByIdTask'
        obj.id = row.IdVinculo
        obj.idTask = row.IdTarefa
        funcTrasform = generateFinMovFromNode
        funcTabs = this.generateModalTabsFinMov
      } else if (row && row.TipoVinculo === 'CL') {
        obj.store = 'getAccountEntryByIdTask'
        obj.url = '/assignment/getAccountEntryByIdTask'
        obj.id = row.IdVinculo
        obj.idTask = row.IdTarefa
        funcTrasform = generateAccountEntryFromNode
        funcTabs = this.generateModalTabsBankStat
      }

      // Chama a rota correta com os detalhes do lançamento
      if (obj && obj.id) {
        this.$store.dispatch(obj.store, obj).then((response) => {
          let data = null
          data = response.data
          if (data) {
            this.detailsObj = funcTrasform(data)
            funcTabs()
            setTimeout(() => {
              this.showDetailsModal()
              window.Grids[0].Disable()
            }, 100)
          } else {
            this.detailsObj = {idProcessamento: '-1'}
            this.generateModalTabTask(obj.idTask.toString())
            setTimeout(() => {
              this.showDetailsModal()
              window.Grids[0].Disable()
            }, 100)
          }
        })
      }
    },

    // Método responsável por criar o array de tipo de vinculo a ser enviado para o MS
    createArrayTypeLinkFilter () {
      let typeLinkArray = []
      if (this.typeLinkSelected && this.typeLinkSelected.length > 0) {
        this.typeLinkSelected.forEach(typeLink => {
          typeLinkArray.push(typeLink.key)
        })
      }
      return typeLinkArray
    },

    // Método responsável por criar o array de situações a ser enviado para o MS
    createArraySituationListFilter () {
      let situationArray = []
      if (this.situationList && this.situationList.length > 0) {
        this.situationList.forEach(situation => {
          if (situation.checked) {
            situationArray.push(situation.id)
          }
        })
      }
      return situationArray
    },

    // Abre a modal de detalhes
    showDetailsModal () {
      trackAnalyticsEvent(this, 'tarefas-open-click', 'open-modal-detalhes-tarefas', 'open-modal-detalhes-tarefas')
      this.isOpenDetailsModal = true
    },

    // Fecha a modal de detalhes
    closeDetailsModal () {
      this.isOpenDetailsModal = false
    },

    // Gera as tabs para a modal de movimento financeiro
    generateModalTabsFinMov () {
      let tabs = []
      this.modalDetailsTabs = []
      // push tab details
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          establishtmentValue: this.detailsObj.establishtmentValue,
          mainValuesList: this.detailsObj.mainValuesList,
          statusValuesList: this.detailsObj.statusValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList,
          commentary: this.detailsObj.commentary
        }
      })

      if (this.detailsObj.idProcessamento) {
        // push tab details
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            establishtmentValue: this.detailsObj.establishtmentValue,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        })
      }

      // push tab historic
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.findFinancialMovementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value
        }
      })

      // push tab allotment
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabAllotment',
        idTabContent: 'tab-allotment-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadAllotmentGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabLote'),
        icon: 'tab-icon-font fa fa-cubes',
        type: 'TabAllotment',
        props: {
          getAllotment: this.findFinancialMovementAllotment,
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: 'MovFin'
        }
      })
      // push tab tasks
      tabs.push({
        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: 'MovFin',
          statusMovimento: this.detailsObj.concSituation,
          idTarefa: null
        }
      })
      this.modalTitle = 'modalDetalhesLanc.titulos.titulo'
      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtitulo'
      this.modalDetailsTabs = tabs
    },

    // Gera as tabs para a modal de conta lançamento
    generateModalTabsBankStat () {
      let tabs = []
      this.modalDetailsTabs = []
      // push tab details
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          mainValuesList: this.detailsObj.mainValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList
        }
      })

      if (this.detailsObj.idProcessamento) {
        // push tab details
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        })
      }

      // push tab historic
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.findBankStatementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value
        }
      })

      // push tab tasks
      tabs.push({
        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: 'MovBan',
          idTarefa: null
        }
      })
      this.modalTitle = 'modalDetalhesLanc.titulos.titulo'
      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtitulo'
      this.modalDetailsTabs = tabs
    },

    // Gera as tabs para a modal de conta lançamento
    generateModalTabTask (idTask) {
      let tabs = []
      this.modalDetailsTabs = []
      // push tab tasks
      tabs.push({
        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTask',
        idTabContent: 'tab-tasks-id',
        // idMovimento: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idTarefa: idTask,
          idMovimento: this.detailsObj.idProcessamento.toString()
        }
      })
      this.modalTitle = 'modalDetalhesLanc.titulos.tituloTarefas'
      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtituloTarefas'
      this.modalDetailsTabs = tabs
    },

    findFinancialMovementHistory (id) {
      let data = {
        idFinancialMovement: id,
        url: '/financialMovements/history'
      }
      return this.$store.dispatch('getHistoricFinancialMovement', data)
    },

    findBankStatementHistory (id) {
      let data = {
        idBankStat: id,
        url: '/bankStatement/history'
      }
      return this.$store.dispatch('getHistoricBankStat', data)
    },

    findFinancialMovementAllotment (id) {
      let data = {
        idFinancialMovement: id,
        url: '/assignment/financialMovements/getAllotmentByMovFinId'
      }
      return this.$store.dispatch('getAllotmentByMovementId', data)
    },

    findIntegration (id) {
      let data = {
        idProcessamento: id,
        url: '/assignment/getProcessedFilesById'
      }
      return this.$store.dispatch('getProcessedFiles', data)
    },

    loadModalFromEmailLink (tarefaId) {
      // Chama a rota correta com os detalhes do lançamento
      this.$store.dispatch('searchTaskBoundType', tarefaId)
        .then((response) => {
          // Evita a exibição de notificação em caso de delay do $router em reagir ao 401
          if (response.status !== 401) {
            if (!response.data || response.data === '') {
              this.$root.$refs.notification.warning('consultaTarefa.labels.tarefaNãoEncontrada')
            } else if (response.data.cliente !== this.client) {
              this.$root.$refs.notification.warning('consultaTarefa.labels.tarefaOutroCliente')
            } else {
              this.prepareGridReactions(response.data)
              this.defaultTab = 'gridDetailsModal-tabTasks'
              this.search()
            }
            this.disableSearchButton = false
          }
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error)
          this.disableSearchButton = false
        })
    },

    // Busca pelas tarefas concluídas
    searchCompletedTasks () {
      this.assignCheck = true
      // Faz a busca
      this.showTreegrid = true
      startTreeGridLoading(self.gridId)
      this.search()
      // Limpa o filtro do vuex
      this.$store.dispatch('clearFilterTaskList')
    },

    // Busca pelas tarefas pendentes e vencidas
    searchOverdueAndPendingTasks (dateFirstDue) {
      this.assignCheck = true
      this.queryBaseSelected = this.queryBaseOptions.find(o => o.id === 2)
      this.dateRange.fromDate = new Date(dateFirstDue)
      this.firstDate = this.dateRange.fromDate
      this.dateRange.toDate = new Date()
      // Faz a busca
      this.showTreegrid = true
      startTreeGridLoading(self.gridId)
      this.search()
      // Limpa o filtro do vuex
      this.$store.dispatch('clearFilterTaskList')
    }
  },

  mounted () {
    this.filteredOriginOptions = [...this.originalOriginOptions]
    let tarefaId = this.$route.query.tarefa
    if (tarefaId) {
      this.loadModalFromEmailLink(tarefaId)
    }
    // Listener para evento de atualização de dados dentro da modal de detalhes,
    // o que requer uma nova consulta para o relatório
    closeModal.$on('modalDetailsClose', (flag) => {
      if (flag) {
        this.showTreegrid = true
        startTreeGridLoading(this.gridId)
        this.search()
        // Altera a flag que recarrega a treegrid após o recarregamento
        // para impedir que ela seja recarregada sempre após a primeira vez
        closeModal.$emit('taskChange', false)
      }
    })

    if (this.situationFilter && this.situationFilter.type && this.situationFilter.arraySituations && this.situationFilter.arraySituations.length > 0) {
      // Desmarca todas as situações
      this.situationList.forEach((sit) => {
        sit.checked = false
      })

      // Verifica as situações passadas para marcar como check
      this.situationFilter.arraySituations.forEach((sitFilter) => {
        let situation = _.findWhere(this.situationList, { id: sitFilter })
        situation.checked = true
      })

      // Monta os filtros e busca conforme a situação passada
      if (this.situationFilter.type === FiltroSituacaoTarefaEnum.NC) {
        this.searchOverdueAndPendingTasks(this.situationFilter.dateFirstDue)
      } else if (this.situationFilter.type === FiltroSituacaoTarefaEnum.C) {
        this.searchCompletedTasks()
      }
    }
  }
}
</script>

<style scoped>
.date-picker {
  border: none;
  height: 36px!important;
  width: 100px;
}

.vdp-datepicker {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 11px 8px!important;
  margin-right: 10px;
}

.check-atribuidas {
  font-weight: bold!important;
}

.spaced-bottom-top {
  margin-bottom: 10px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// List.vue?9fa07b72